import React from "react";
import { AxiosError } from "axios";
import { QueryResult } from "react-query";
import { useTranslation } from "react-i18next";

import { ApiError } from "fe-shared/src/types/common";

import InvoiceStatus from "components/InvoiceStatus";
import { ReturnIcon } from "fe-shared/src/components/Icons";
import { LinkButton, Loader, NotFoundPage } from "fe-shared/src/components";
import {
  InvoiceHeaderInfo,
  InvoiceContentView,
} from "fe-shared-transactions/src/components";

import { Invoice } from "fe-shared-transactions/src/types";

import styles from "./InvoicesDetailsView.module.scss";

interface Props {
  returnUrl: string;
  invoice: QueryResult<Invoice, AxiosError<ApiError>>;
}

const InvoicesDetailsView = (props: Props) => {
  const { returnUrl, invoice } = props;
  const { data, isFetching, isLoading, isError } = invoice;

  const { t } = useTranslation();

  const isInvoiceNotFound = invoice.error?.response?.status === 404;

  const renderContent = () => {
    return (
      <main className={styles.reqDetailsContent}>
        <div className={styles.reqDetailsContentWrapper}>
          <div className={styles.reqDetailsNavigation}>
            <LinkButton
              to={returnUrl}
              variant="inline"
              id="request-back-link"
              iconComponent={ReturnIcon}
              className={styles.reqDetailsBackLink}
            >
              {t("invoices.grid.title")}
            </LinkButton>
          </div>
          <div className={styles.reqDetailsData}>
            <InvoiceStatus invoice={data!} />
            <InvoiceHeaderInfo invoice={data!} />
            <InvoiceContentView invoice={data!} />
          </div>
        </div>
      </main>
    );
  };

  return (
    <div className={styles.reqDetails}>
      {isFetching && <Loader isBlocking />}
      {!isLoading && !isError && data && renderContent()}
      {isError && (
        <NotFoundPage
          returnLink="/invoices"
          title={
            isInvoiceNotFound
              ? "invoices.details.error.notFoundTitle"
              : "errors.somethingWrong"
          }
          descriptions={["invoices.details.error.description"]}
          returnLinkDescription="invoices.details.error.returnLink"
        />
      )}
    </div>
  );
};

export default InvoicesDetailsView;
